import React, { useState, useEffect } from 'react';
import herobg from '../../assets/support/herobg.png';

const HeroSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section
            className="relative w-full h-screen flex items-center justify-center overflow-hidden"
            role="banner"
            aria-label="RoadExpress contact us hero section"
        >
            {/* Background Video */}
            <video
                className="absolute inset-0 w-full h-full object-cover scale-105"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                onError={(e) => {
                    console.error('Video failed to load:', e);
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'block';
                }}
            >
                <source src="https://prod-roadexpress.s3.ap-south-1.amazonaws.com/website/supportpage.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 z-10" aria-hidden="true"></div>

            {/* Content */}
            <div className="relative z-20 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    {/* Heading */}
                    <div
                        className={`transform transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                            }`}
                        style={{ transitionDelay: '0.2s' }}
                    >
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white">
                            <span className="text-[#F05A28]">Let's Connect</span>
                            <br />
                            We're Here to Help
                        </h1>
                    </div>

                    {/* Description */}
                    <div
                        className={`transform transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                            }`}
                        style={{ transitionDelay: '0.4s' }}
                    >
                        <p className="text-lg md:text-xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-8">
                            Have questions or need assistance? Reach out to our support team and we’ll get back to you as soon as possible.
                        </p>
                    </div>
                </div>
            </div>

            {/* Structured Data for SEO */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "RoadExpress",
                        "url": "https://www.roadexpressfreight.com/support",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-844-773-8498",
                            "contactType": "Customer Support",
                            "areaServed": "IN",
                            "availableLanguage": ["English", "Hindi"]
                        }
                    })
                }}
            />
        </section>
    );
};

export default HeroSection;
